﻿import React from 'react';
import styled from 'styled-components';
import { IColumn, orderCharLookup, IOrderStatus } from './Table';

const HeaderCell = styled.div`
    height: 40px;
    width: ${props => props.theme.width}px;
    min-width: ${props => props.theme.minWidth}px;
    max-width: ${props => props.theme.width}px;
`

interface ITableHeaderCellProps {
    column: IColumn;
    reOrder: (col: number) => void;
    orderStatus?: IOrderStatus;
}

interface ICellContent{
    showPointer: boolean;
}

const CellContent = styled.div<ICellContent>`
    display: flex;
    align-items: center;
    margin: 2px 0 0 8px;
    height: calc(100% - 4px);
    width: calc(100% - 16px);
    user-select: none;
    & span {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    &:hover {
        cursor: ${props => props.showPointer ? `default` : `pointer`};
    }
`

export const TableHeaderCell: React.FunctionComponent<ITableHeaderCellProps> = (props) => {
    const orderSymbolCheck = props.orderStatus && props.column.columnKey === props.orderStatus.columnId;
    return (<HeaderCell theme={{ width: props.column.width }}>
        <CellContent showPointer={props.column.disableReOrder} onMouseDown={() => { props.reOrder(props.column.columnKey) }}>
            <span>{props.column.displayName}{orderSymbolCheck && orderCharLookup[props.orderStatus.orderBy]}</span>
        </CellContent>
    </HeaderCell>);
}